import React, { Suspense } from 'react';
import { ActivityIndicator } from '../../../components/common/activity-indicator/activity-indicator';
import SupportAccordion from '../../components/support-accordion/support-accordion';
import { RecallsProps } from '../recalls/hook/use-recalls-content';
import { RecallsApiResponse } from '../../../services/recalls-service/recalls-service';
import { isIMGTakataRoute } from './recalls-util';

interface Props {
    recallsContent: RecallsProps;
    recallData: RecallsApiResponse | null | undefined;
}

export const RecallsSupportAccordion = (props: Props) => {
    const isImgTakataRoute = isIMGTakataRoute();
    const recallsResultsFaqClickEvent = isImgTakataRoute
        ? 'takata-recalls-results-faq'
        : 'recalls-results-faq';
    return (
        <>
            {props.recallsContent.recallsDetailsAccordionTitle &&
            ((props.recallData?.cspCount && props.recallData?.cspCount > 0) ||
                (props.recallData?.recallsCount &&
                    props.recallData?.recallsCount > 0)) ? (
                <>
                    <h2 className="info-title faq-header">
                        {props.recallsContent.recallsDetailsAccordionTitle}
                    </h2>

                    <div className="faq-accordion" data-testid="faq-accordion">
                        <Suspense fallback={<ActivityIndicator />}>
                            <SupportAccordion
                                contentServiceDirectory="recalls"
                                contentServiceName="recallsAccordion"
                                contentServiceComponentName="accordion"
                                eventName={recallsResultsFaqClickEvent}
                                description={
                                    props.recallsContent.accordionDescription
                                }
                            />
                        </Suspense>
                    </div>
                </>
            ) : (
                <></>
            )}
        </>
    );
};
